/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import {
  fetchCoveredStates,
  fetchLicenseTable,
  postAddLicense,
  fetchDeleteLicense,
  postEditLicense,
} from 'legacy/containers/ApiUrls';

// Constants Types
import {
  COVERED_STATE_FETCH_REQUEST,
  COVERED_STATE_FETCH_SUCCESS,
  COVERED_STATE_FETCH_FAILURE,
  LICENSETABLE_FETCH_REQUEST,
  LICENSETABLE_FETCH_SUCCESS,
  LICENSETABLE_FETCH_FAILURE,
  LICENSETABLE_ADD_REQUEST,
  LICENSETABLE_ADD_SUCCESS,
  LICENSETABLE_ADD_FAILURE,
  LICENSETABLE_DELETE_REQUEST,
  LICENSETABLE_DELETE_SUCCESS,
  LICENSETABLE_DELETE_FAILURE,
  LICENSETABLE_EDIT_REQUEST,
  LICENSETABLE_EDIT_SUCCESS,
  LICENSETABLE_EDIT_FAILURE,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------

export const fetchCoveredStateRequest = () => ({
  type: COVERED_STATE_FETCH_REQUEST,
});
export const fetchCoveredStateSuccess = data => ({
  type: COVERED_STATE_FETCH_SUCCESS,
  payload: data,
});
export const fetchCoveredStateFailure = err => ({
  type: COVERED_STATE_FETCH_FAILURE,
  payload: err,
});
export const fetchLicenseTableRequest = () => ({
  type: LICENSETABLE_FETCH_REQUEST,
});
export const fetchLicenseTableSuccess = data => ({
  type: LICENSETABLE_FETCH_SUCCESS,
  payload: data,
});
export const fetchLicenseTableFailure = err => ({
  type: LICENSETABLE_FETCH_FAILURE,
  payload: err,
});
export const addLicenseTableRequest = () => ({
  type: LICENSETABLE_ADD_REQUEST,
});
export const addLicenseTableSuccess = data => ({
  type: LICENSETABLE_ADD_SUCCESS,
  payload: data,
});
export const addLicenseTableFailure = err => ({
  type: LICENSETABLE_ADD_FAILURE,
  payload: err,
});
export const deleteLicenseTableRequest = () => ({
  type: LICENSETABLE_DELETE_REQUEST,
});
export const deleteLicenseTableSuccess = data => ({
  type: LICENSETABLE_DELETE_SUCCESS,
  payload: data,
});
export const deleteLicenseTableFailure = err => ({
  type: LICENSETABLE_DELETE_FAILURE,
  payload: err,
});
export const editLicenseTableRequest = () => ({
  type: LICENSETABLE_EDIT_REQUEST,
});
export const editLicenseTableSuccess = data => ({
  type: LICENSETABLE_EDIT_SUCCESS,
  payload: data,
});
export const editLicenseTableFailure = err => ({
  type: LICENSETABLE_EDIT_FAILURE,
  payload: err,
});

export const handleFetchCoveredState = () => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  dispatch(fetchCoveredStateRequest());

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { profile, teams } = me.data;
      return Promise.all([dispatch(fetchCoveredStates(profile.id))]);
    })
    .then(data => dispatch(fetchCoveredStateSuccess(data)))
    .catch(err => {
      dispatch(fetchCoveredStateFailure(err));
    });
};

// data for license table
export const fetchLicenseTableInfo = () => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  dispatch(fetchLicenseTableRequest());

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { profile, teams } = me.data;
      const { selectedTeamMemberId } = getState().teamMemberFile;
      if(profile.permissions.isAdmin && selectedTeamMemberId!==null)
      return Promise.all([dispatch(fetchLicenseTable(selectedTeamMemberId))]);
      else
      return Promise.all([dispatch(fetchLicenseTable(profile.id))]);
    })
    .then(data => dispatch(fetchLicenseTableSuccess(data)))
    .catch(err => {
      dispatch(fetchLicenseTableFailure(err));
    });
};

export const handleAddLicense = formData => (dispatch, getState) => {
  dispatch(addLicenseTableRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      dispatch(addLicenseTableRequest());
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { profile } = me.data;
      const apiCalls = [];
      const { selectedTeamMemberId } = getState().teamMemberFile;
      if(profile.permissions.isAdmin){
      apiCalls.push(dispatch(postAddLicense(selectedTeamMemberId, formData)));
      }
      else{
      apiCalls.push(dispatch(postAddLicense(profile.id, formData)));
      }
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(addLicenseTableSuccess(data));
    })
    .then(data => {
      return dispatch(fetchLicenseTableInfo());
    })
    .catch(err => {
      return dispatch(addLicenseTableFailure(err));
    });
};

export const handleDeleteLicense = rowId => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  dispatch(deleteLicenseTableRequest());

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { selectedTeamMemberId } = getState().teamMemberFile;
      const { profile } = me.data;
      if(profile.permissions.isAdmin)
      return Promise.all([dispatch(fetchDeleteLicense(selectedTeamMemberId, rowId))]);
      else
      return Promise.all([dispatch(fetchDeleteLicense(profile.id, rowId))]);
    })
    .then(data => dispatch(deleteLicenseTableSuccess(data)))
    .then(data => {
      return dispatch(fetchLicenseTableInfo());
    })
    .catch(err => {
      dispatch(deleteLicenseTableFailure(err));
    });
};

export const handleEditLicense = formData => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      dispatch(editLicenseTableRequest());
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { selectedTeamMemberId } = getState().teamMemberFile;
      const { profile } = me.data;
      const apiCalls = [];
      const postData = formData.map((item, index) => {
        return {
          ...item,
          memberId: selectedTeamMemberId,
        };
      });
      console.log(postData);
      apiCalls.push(dispatch(postEditLicense(selectedTeamMemberId, postData)));
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(editLicenseTableSuccess(data));
    })
    .then(data => {
      return dispatch(fetchLicenseTableInfo());
    })
    .catch(err => {
      return dispatch(editLicenseTableFailure(err));
    });
};



// WEBPACK FOOTER //
// ./src/views/state/MyInfoSettings/MyInfoSettingsActions.js